/**
 * LockedSection — placeholder for paid fields when the result is locked.
 *
 * Free preview leaves out: Realness Audit, Subtext Read, flags,
 * why_it_matters, what_to_ask_next, what_not_to_do, replies.
 * Each is shown here as a blurred-out teaser with an unlock CTA.
 */
import { Lock } from "lucide-react";

export const LockedSection = ({ title, blurb, icon, onUnlock, testId }) => (
  <div className="mb-6" data-testid={testId}>
    <h3 className="ss-eyebrow mb-3 flex items-center gap-1.5" style={{ color: "var(--ss-muted)" }}>
      {icon}
      {title}
      <span className="ml-2 inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] uppercase tracking-wider" style={{ background: "var(--ss-bg-deep)", color: "var(--ss-gold-deep)" }}>
        <Lock className="w-2.5 h-2.5" strokeWidth={2.5} />
        Locked
      </span>
    </h3>
    <div
      className="relative p-4 rounded-lg"
      style={{ background: "var(--ss-card-2)", borderLeft: "3px solid var(--ss-rule-line)" }}
    >
      <p
        className="text-base sm:text-lg leading-relaxed select-none"
        style={{
          color: "var(--ss-ink-2)",
          filter: "blur(4px)",
          opacity: 0.55,
          userSelect: "none",
        }}
        aria-hidden
      >
        {blurb}
      </p>
      <button
        onClick={onUnlock}
        data-testid={`${testId}-unlock`}
        className="absolute inset-0 flex items-center justify-center text-sm font-semibold rounded-lg"
        style={{ color: "var(--ss-gold-deep)" }}
      >
        <span
          className="px-3 py-1.5 rounded-full border"
          style={{
            background: "var(--ss-card)",
            borderColor: "var(--ss-gold)",
            boxShadow: "var(--ss-shadow)",
          }}
        >
          Get the Full Read →
        </span>
      </button>
    </div>
  </div>
);
